<selfai-platform-model-version
  [versions]="versions$ | async"
  (backEvent)="onBack()"
  (submitEvent)="onSubmit($event)"
></selfai-platform-model-version>
